
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MaterialRequestBOMGrid extends Serenity.EntityGrid<MaterialRequestBOMRow, any> {
        protected getColumnsKey() { return 'Inventory.MaterialRequestBOM'; }
        protected getDialogType() { return MaterialRequestBOMDialog; }
        protected getIdProperty() { return MaterialRequestBOMRow.idProperty; }
        protected getInsertPermission() { return MaterialRequestBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return MaterialRequestBOMRow.localTextPrefix; }
        protected getService() { return MaterialRequestBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}